import playIcon from "@/assets/music-player/play.svg";
import playHover from "@/assets/voices/card/play-hover.svg";
import pauseActive from "@/assets/music-player/stop-pressed.svg";
import Image from "next/image";
import useHover from "@/hooks/use-hover";

type PlayerButtonProps = {
  handleClick: () => Promise<void>;
  isPlaying: boolean;
  size?: number;
};

const PlayerButton = ({
  handleClick,
  isPlaying,
  size = 32,
}: PlayerButtonProps) => {
  const { isHovering, onMouseLeave, onMouseEnter } = useHover();

  const icon = isPlaying ? pauseActive : isHovering ? playHover : playIcon;

  return (
    <Image
      alt={isPlaying ? "pause" : "play"}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      onClick={handleClick}
      src={icon}
      height={size}
      width={size}
      style={{ cursor: "pointer" }}
    />
  );
};

export default PlayerButton;
